import AccesosDirectos from 'common/components/AccesosDirectos'

const Enlaces = () => {
  return <AccesosDirectos sx={{ mt: 0, mb: 2 }} codigo="ENLACES" clean />
}

export default Enlaces
